import React from 'react';
import {navigation} from "../containers/App";
import {Link} from "react-router-dom";

function Footer() {
    return <footer>
        <div className={"footer-content"}>
            <div className={"left"}>
                <div className={"logo"}/>
                <div>info@tetoesterkomosas.hu</div>
                {/*<div className={"socials"}>*/}
                {/*    <div className={"facebook"}/>*/}
                {/*    <div className={"instagram"}/>*/}
                {/*</div>*/}
            </div>
            <div className={"middle"}>
                <div className={"title"}>Gyors Linkek</div>
                {Object.entries(navigation).map(([key, value]) => <Link key={key} to={{pathname: "", hash: "#" + key}}>{value}</Link>)}
            </div>
            <div className={"right"}>
                <div className={"title"}>Dokumentumok</div>
                <Link to={"/tajekoztato/adatkezelesi"}>Adatkezelési tájékoztató</Link>
                <Link to={"/tajekoztato/sutikezelesi"}>Sütikezelési tájékoztató</Link>
                <Link to={"/tajekoztato/impresszum"}>Impresszum</Link>
                <Link to={"/tajekoztato/aszf"}>Általános szerződési feltételek</Link>
            </div>
        </div>
        <div className={"copyright"}>© 2025 Tető- és térkőmosás | Minden jog fenntartva</div>
    </footer>
}

export default Footer;